export default function warn() {
  var _console;

  typeof window !== 'undefined' && console && console.warn && (_console = console).warn.apply(_console, arguments);
}